import { PaymentRequirementStrategy } from "@wingspanhq/payments/dist/interfaces";
import {
  PayerPayeeEngagementSearchableStatus,
  PayerPayeeSearchableTinStatus
} from "../../../../../services/search";
import { FiltersValueBase } from "../../../../../shared/hooks/useUrlQueryFilters";

export enum PayeeFilterShareTaxDocument {
  Shared = "Shared",
  NotShared = "NotShared"
}

export enum PayeeFilterEligibilityStatus {
  All = "All",
  Eligible = "Eligible",
  NotEligible = "NotEligible",
  SpecificRequirement = "SpecificRequirement"
}

export enum PayeeFilterRequirementStatus {
  All = "All",

  // Requirement type specific filters
  AwaitingContractorSignature = "AwaitingContractorSignature",
  AwaitingClientSignature = "AwaitingClientSignature",
  PendingBackgroundCheck = "PendingBackgroundCheck",
  ProcessingBackgroundCheck = "ProcessingBackgroundCheck",
  FailedBackgroundCheck = "FailedBackgroundCheck",

  // Requirement status
  Incomplete = "Incomplete",
  Complete = "Complete",

  // Review status
  PendingApproval = "PendingApproval",
  Rejected = "Rejected",
  Approved = "Approved"
}

export interface PayeeFilters extends FiltersValueBase {
  searchableStatus?: PayerPayeeEngagementSearchableStatus[];
  eligibilityStatus?: PayeeFilterEligibilityStatus;
  requirementStatus?: PayeeFilterRequirementStatus;
  requirementDefinitionId?: string;
  searchableTinStatus?: PayerPayeeSearchableTinStatus[];
  shareTaxDocument?: PayeeFilterShareTaxDocument[];
  payerId?: string[];
  engagementId?: string;
  autoPayStrategy?: PaymentRequirementStrategy[];
  bulkBatchId?: string;
}
